import {gql} from '@apollo/client'

export const GET_BIRTHDAYS_BY_MONTH = gql`
  query birthdaysByMonth($month: Int!, $day: Int, $effectiveYear: Int, $memberType: String) {
    birthdaysByMonth(month: $month, day: $day, effectiveYear: $effectiveYear, memberType: $memberType) {
      isPartial
      totalCount
      contacts {
        id
        firstName
        middleName
        lastName
        secondLastName
        dateBirth
        phone
        user {
          id
          firstName
          lastName
          npn
        }
        memberPolicy {
          rol
          policy {
            user {
              id
              firstName
              lastName
              npn
            }
          }
        }
        members {
          edges {
            node {
              rol
            }
          }
        }
      }
    }
  }
`
